/* @global Copier */
import React, { Component } from "react";
import cx from "classnames";
import distanceInWordsToNow from "date-fns/distance_in_words_to_now";
import _find from "lodash/find";
import _includes from "lodash/includes";

import Carousel from "./Carousel";
import Button, { ButtonBasic } from "./Button";
import Icon from "./Icon";
import Score from "./Score";
import Distance from "../containers/DistanceContainer";
import { bodyTypes } from "../config";
import { formatMoney, getHumanDuration, showScore } from "../utils";

export default class ModelItem extends Component {
  state = {
    share: false,
  };

  selectText(ev) {
    ev.target.select();
  }

  _cancelEvent = (ev) => {
    ev.stopPropagation();
  };

  _onShare = (ev) => {
    ev.stopPropagation();
    this.setState({ share: true });
  };

  _closeShare = (ev) => {
    this.setState({ share: false });
  };

  _onCopy = (ev) => {
    Copier.copy(`https://smooci.com/escorts/${this.props.model.hash}`);
    this._closeShare();
  };

  _onClick = (ev) => {
    const { model, city } = this.props;
    const isMultiCity = model.city.multi && model.city.multi.length > 0;
    const isAway = isMultiCity && !_includes(model.city.multi, city.id);

    if (!isAway && !ev.target.classList.contains("slick-arrow")) {
      this.props.showModel(model.id);
    }
  };

  _onBook = (ev) => {
    ev.stopPropagation();
    this.props.onBook(this.props.model.id);
  };

  _toggleFavorite = (ev) => {
    const { model, isFavorite } = this.props;

    ev.stopPropagation();

    if (isFavorite) {
      this.props.onUnfavorite(model.id);
    } else {
      this.props.onFavorite(model.id);
    }
  };

  render() {
    const {
      discount,
      model,
      rate,
      perHour,
      city,
      brand,
      duration,
      isPremium,
      isFavorite,
      isOnline,
      isBookable,
      outcall,
      distance,
    } = this.props;

    const { share } = this.state;
    const isMultiCity = model.city.multi && model.city.multi.length > 0;
    const isAway = isMultiCity && !_includes(model.city.multi, city.id);

    // Area (incall)
    let area;

    if (!outcall && model.location) {
      area = model.location.area;
    } else {
      area = null;
    }

    const bodyType = _find(
      bodyTypes,
      (bodyType) => bodyType.id === model.bodyType
    );

    // FIXME: Way too hard-coded.
    const shareUrl = `https://smooci.com/escorts/${model.hash}`;

    let images = model.images || [];

    if (model.image) {
      // Put default image first
      images = images.filter((img) => img.id !== model.image.id);
      images.unshift(model.image);
    }

    return (
      <li className="o-layout__item u-1/2@m" onClick={this._onClick}>
        <div
          className={cx("card", "modelItem", {
            "modelItem--offline": !isOnline,
            "modelItem--disabled": isAway,
            "modelItem--gray": !isOnline && city.matured,
          })}
        >
          <div className="card__image">
            {images.length > 0 && (
              <Carousel
                {...{
                  hash: model.hash,
                  images,
                  isPremium,
                }}
              />
            )}
            <div className="modelItem__tags">
              {!!model.acceptPremiumOnly && (
                <small className="modelItem__tag u-mr-tiny">premium only</small>
              )}
              {model.videoCount > 0 && (
                <small className="modelItem__videos u-mr-tiny">
                  <i className="icon icon-play_circle_outline icon--small" />
                  <span className="u-ml-tiny">{model.videoCount} videos</span>
                </small>
              )}
              {!isOnline &&
                (model.socials || []).length > 0 &&
                model.socials.map(({ slug }) => (
                  <img
                    src={`/img/${slug}-logo.png`}
                    className="modelItem__social"
                  />
                ))}
            </div>
          </div>
          <div className="modelItem__dot" />
          {share && (
            <div className="modelItem__share" onClick={this._cancelEvent}>
              <input
                type="text"
                className="form__control form__control--small"
                readOnly
                value={shareUrl}
                autoFocus
                onFocus={this.selectText}
                onClick={this.selectText}
              />
              <Button
                full
                small
                title="Copy to clipboard"
                onClick={this._onCopy}
              />
              <p className="u-mt">
                <a className="u-link u-small" onClick={this._closeShare}>
                  CLOSE
                </a>
              </p>
            </div>
          )}
          <div className="modelItem__utils">
            <Icon name="share" medium onClick={this._onShare} />
            {isPremium && (
              <Icon
                name={isFavorite ? "favorite" : "favorite_border"}
                medium
                active={isFavorite}
                onClick={this._toggleFavorite}
              />
            )}
          </div>
          <div className="card__content">
            <ModelItemHeader
              name={model.name}
              age={model.age}
              ageVerified={model.ageVerified}
              brandName={model.independent ? "Independent" : brand.name}
              xo={!!model.xo}
            />
            <ModelItemMeta
              {...{
                modelId: model.id,
                cityName: isMultiCity && model.city.name,
                height: model.height,
                bodyType: bodyType.name,
                area,
                reviewsCount: model.reviewsCount,
                ratingsCount: model.ratingsCount,
                rating: model.score,
                isPremium,
              }}
            />
          </div>
          <ModelItemFooter
            {...{
              discount,
              rate,
              perHour,
              countryId: city.country_id,
              isPremium,
              isAway,
              isBookable,
              isTooFar: distance > city.booking_distance,
              modelCityName: model.city.name,
              modelId: model.id,
              duration: getHumanDuration(duration),
              isOffline: !isOnline,
              offlineAt: model.offlineAt,
              onBook: this._onBook,
            }}
          />
        </div>
      </li>
    );
  }
}

function ModelItemHeader({ name, age, ageVerified, brandName, xo }) {
  return (
    <div className="card__header u-clearfix">
      <div className="card__title title">
        <span>{name}</span>
        <small className={cx({ "u-verified": ageVerified })}>
          ({age} years old{ageVerified && <Icon name="check" small />})
        </small>
        {xo && <img className="u-ml-tiny" src="/img/xo.png" width="16" />}
      </div>
      <small className="card__meta">{brandName}</small>
    </div>
  );
}

function ModelItemMeta({
  modelId,
  cityName,
  height,
  bodyType,
  reviewsCount,
  ratingsCount,
  rating,
  isPremium,
}) {
  return (
    <div className="card__meta">
      <div className="u-clearfix">
        <ul className="card__metas">
          <li>{height} cm</li>
          <li>{bodyType}</li>
        </ul>
        <ul className="o-list-inline card__rating">
          {isPremium && (
            <li>
              <span className="u-underline">
                {reviewsCount > 30 ? "30+" : reviewsCount} reviews
              </span>
            </li>
          )}
          {showScore(ratingsCount, rating) && (
            <li>
              <Score value={rating} />
            </li>
          )}
        </ul>
      </div>
      <div className="u-clearfix">
        <Distance modelId={modelId} className="u-brand u-fl" />
        {Boolean(cityName) && <div className="u-fr">{cityName}</div>}
      </div>
    </div>
  );
}

class ModelItemFooter extends Component {
  _stopPropagation = (ev) => ev.stopPropagation();

  render() {
    const {
      discount,
      rate,
      perHour,
      countryId,
      duration,
      isOffline,
      isAway,
      isBookable,
      isTooFar,
      modelCityName,
      modelId,
      offlineAt,
      onBook,
      isPremium,
    } = this.props;

    let price;

    if (rate) {
      price = isPremium ? rate.amount - discount : rate.amount;
    }

    return (
      <div className="card__footer u-clearfix">
        {Boolean(rate) && !isAway && (
          <div className="u-fl">
            <strong>{formatMoney(price, countryId)}</strong>
            <small>({duration})</small>
          </div>
        )}
        {Boolean(perHour) && !isAway && (
          <div className="u-fl">
            <small>~ {formatMoney(perHour, countryId)} / h</small>
          </div>
        )}
        {isAway && (
          <div className="u-fl">
            <small>{modelCityName}</small>
          </div>
        )}
        {!isOffline && isBookable && (
          <div className="u-fr">
            <ButtonBasic title="Send request" tiny onClick={onBook} />
          </div>
        )}
        {!isOffline && (
          <div className="u-fr">
            <ButtonBasic
              {...{
                title: "Chat",
                mod: "brand",
                icon: "chat",
                tiny: true,
                href: `/chats?model=${modelId}`,
                onClick: this._stopPropagation,
              }}
            />
          </div>
        )}
        {isOffline && (
          <div className="u-fr u-xsmall u-muted">
            {Boolean(offlineAt)
              ? `Last seen ${distanceInWordsToNow(
                  new Date(offlineAt * 1000)
                )} ago`
              : "Offline"}
          </div>
        )}
        {!isOffline && isTooFar && (
          <div className="u-fr u-small u-muted">Location too far</div>
        )}
      </div>
    );
  }
}
